import { Component, Injector, OnInit } from '@angular/core';
import { HotelService } from '../../../core/services/hotel.service';
import { BaseNewComponents } from '../../base-new-components';

interface HotelsHighlights {
  images: string[];
  alt: string;
  slug: string;
  name: string;
  state: string;
  city: string;
  contractCode: number;
  highlightType: number;
}
@Component({
  selector: 'app-hotels-informations',
  templateUrl: './hotels-informations.component.html',
  styleUrls: ['./hotels-informations.component.sass']
})
export class HotelsInformationsComponent extends BaseNewComponents implements OnInit {
  highlightsList: HotelsHighlights[]  = [];
  premiumList: HotelsHighlights[] = [];
  newList: HotelsHighlights[] = [];
  constructor(
      protected injector: Injector,
      public hotelService: HotelService,
  ) {
    super(injector);
  }

  async ngOnInit() {
    await this.loadHotels();
  }

  async loadHotels() {
    const result = this.hotelService.fetchHotelsStaticHighlights();
    if (result) {
      const data = result.data.map(item => {
        return {
          images: item.fotos,
          slug: item.slug,
          alt: item.slug,
          name: item.nome,
          state: item.uf,
          city: item.cidade,
          contractCode: item.codContrato,
          highlightType: item.tipoDestaque,
        };
      });
      this.highlightsList = data.filter(item => item.highlightType === 36);
      this.premiumList = data.filter(item => item.highlightType === 39);
      this.newList = data.filter(item => item.highlightType === 0);
    }
  }

  navigateToHotelDetails(contractCode: number, slug: string): void {
    const param = contractCode + '_' + slug;
    this.router.navigate(['/hoteis/hotel/', param]);
  }
}
